import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {LoaderService} from "../../components/loader/loader.service";
import  {ShopService} from "../../services/shops/shops.service";
import template from './ppcScaleConfig.tpl.html';


interface PPCScaleConfigScope extends ConfigScope {
  machines: apsViewModels.MachineConfiguration[];
}

export default angular.module('aps.controller.ppcScaleConfig', [])
  .directive('apsPpcScaleConfig', ( 
          loaderService: LoaderService,
          shopService: ShopService): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: PPCScaleConfigScope) => {
      
        let updateMachines = () => {
          if (!scope.vm.location) {
            return;
          }
          let getMachines = shopService.getShopConfiguration(scope.vm.location.id)
            .then(shop => scope.machines = shop.machineConfigurations);
          loaderService.loadingPromise(getMachines);
        };
  
        updateMachines();
  
        scope.$watch('vm.location', updateMachines);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/ppcScaleConfig.directive.ts